<template>
  <div>        
    <div>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
                <label>Empresa</label>
                <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                    @change="listarCentrosCustos"/>
            </div>
                <div class="p-field p-col-12 p-md-4">
                <label>Centro de custo</label>
                <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Todos"
                    :filter="true" :showClear="true"/>
            </div>  
            <div class="p-field p-col-0">
                <label style="color:#ffffff">.</label>  
                <Button label="Buscar" icon="pi pi-search" @click="listar()"/>
            </div>                              
        </div> 
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">                        
                <div class="p-inputgroup">
                    <InputText v-model.trim="crachaNome" 
                    @keyup.enter="listarPorCrachNome()" 
                    @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')"  
                    placeholder="crachá/pis/cpf/nome"/>
                    <Button icon="pi pi-search" title="Buscar" @click="listarPorCrachNome()"/>                    
                </div>
            </div>
        </div>
        <DataTable :value="afastamentos" :filters="filtro" :paginator="true" :rows="10"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
            class="p-datatable-sm p-datatable-striped">
            <template #header>
                <div class="table-header">	
                    <div class="p-d-flex p-jc-end">			
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText v-model="filtro['global']" placeholder="Filtrar..." />
                        </span>
                    </div>
                </div>
            </template>
            <Column field="crachaFuncionario" header="Crachá" sortable></Column>
            <Column field="nomeFuncionario" header="Nome" sortable></Column>
            <Column field="motivo" header="Motivo" sortable></Column>
            <Column field="dataInicio" header="Data início" sortable></Column> 
            <Column field="dataFinal" header="Data final" sortable></Column>   
            <Column>
                <template #body="slotProps">                    
                    <Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>							
                </template>
            </Column>         
        </DataTable> 
        
        <Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                <span>Excluir afastamento?</span>
                <p>
                    <br/>
                    Funcionário: <b>{{ afastamentosSelecionado.nomeFuncionario }}</b><br/>
                    Motivo: <b>{{ afastamentosSelecionado.motivo }}</b><br/>
                    Data: 
                    <b v-if="afastamentosSelecionado.definitivo">{{ afastamentosSelecionado.dataFinal }}</b>
                    <b v-else>de {{ afastamentosSelecionado.dataInicio }} até {{ afastamentosSelecionado.dataFinal }}</b>
                </p>
            </div>
            <template #footer>
                <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
                <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
            </template>
        </Dialog>

    </div>
  </div>
</template>

<script>
import CentroCustoService from '@/service/CentroCustoService';
import AfastamentoService from '@/service/AfastamentoService';
import ControlePontoService from '@/service/ControlePontoService.js';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
    controlePontoService: null,
    afastamentoService: null,
    centroCustoService: null,
    data() {
        return {
            listarTodos: true,
            crachaNome: '',           
            exibirDialogConfirmarExcluir: false,         
            afastamentosSelecionado: {id: null, nomeFuncionario: '', motivo: '', dataInicio: null, dataFinal: null},          
			permissaoExcluir: false,         
            afastamentos: [],
            idCentroCustoSelecionado: null,
            idCnpjSelecionado: null,
            cnpjs: [],
            centrosCustos: [],
            filtro: {},
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes', 'getCacheEmpresa']),    
        /**
         * 
         */
        excluir() {            
            let cnpjSelecionado = null;
            this.cnpjs.forEach(cnpj => {
                if(this.idCnpjSelecionado == cnpj.id) {
                    cnpjSelecionado = cnpj;
                }
            });
            let requisicao = {   
                cnpj: cnpjSelecionado,           
                idAfastamento: this.afastamentosSelecionado.id,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };	
            let funcionario = {
                id: this.afastamentosSelecionado.idFuncionario,
                nome: this.afastamentosSelecionado.nomeFuncionario,
                pis: this.afastamentosSelecionado.pisFuncionario,
            }
			this.afastamentoService.excluir(requisicao)
            .then(resp => {             
                if(resp.data instanceof Array) {
                    exibirMensagemSis(this, 'Sucesso', false);     
                } else {
                    exibirMensagem(this, resp);   
                }                        
                this.limparExcluir();
                this.listar();
                if(resp.data instanceof Array && resp.data.length > 0) {
                    let novaRequisicao = {
                        mes: resp.data[0].mes,
                        ano: resp.data[0].ano,
                        dataInicio: resp.data[0].dataInicio,
                        dataFinal: resp.data[0].dataFinal,
                        cnpj: cnpjSelecionado,
                        funcionario:  {
                            id: funcionario.id,
                            nome: funcionario.nome,
                            pis: funcionario.pis
                        },      
                        usuarioRequisicao: {...this.getDadosRequisicao()},          
                    };
                    this.calcularPeriodoEditado(novaRequisicao);
                }
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
         calcularPeriodoEditado(requisicao) {           
            this.controlePontoService.calcularPeriodoEditado2(requisicao)
            .then()
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        listar() {            
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {               
                this.centrosCustos.forEach(ctc => {
                    if(ctc.id != null) {
                        idsCentrosCustos.push(ctc.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }            
            let requisicao = {  
                idsCentrosCustos: idsCentrosCustos,  
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };	
			this.afastamentoService.listar(requisicao)
            .then(resp => {                 
                this.listarTodos = true;   
                this.afastamentos = resp.data;           
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        /**
         * 
         */
        listarPorCrachNome() {            
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            if(this.crachaNome == '') {               
                return;
            }           
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {               
                this.centrosCustos.forEach(ctc => {
                    if(ctc.id != null) {
                        idsCentrosCustos.push(ctc.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
            }            
            let requisicao = {  
                crachaNome: this.crachaNome,
                idsCentrosCustos: idsCentrosCustos,  
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };	
			this.afastamentoService.listarPorCrachNome(requisicao)
            .then(resp => {       
                this.listarTodos = false;             
                this.afastamentos = resp.data;           
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },   
        /**
         * 
         */
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },  
        /**
         * 
         */  
		confirmarExcluir(afastamento) {
			this.afastamentosSelecionado = afastamento;
			this.exibirDialogConfirmarExcluir = true;
		},
        /**
         * 
         */
		limparExcluir() {
			this.afastamentosSelecionado = {id: null, nomeFuncionario: '', motivo: '', dataInicio: null, dataFinal: null};
			this.exibirDialogConfirmarExcluir = false;
        },	  
        /**
         * 
         */      
        listarCnpjs() {
            if(this.cnpjs.length > 0) {                
                return
            }           
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        /**
         * 
         */
        listarCentrosCustos() {           
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => { 
                this.idContratoSelecionado = null;                     
                this.centrosCustos = []; 
                let centroCusto = new CentroCusto();
                centroCusto.nome = 'Todos';
                this.centrosCustos.push(centroCusto);
                Array.prototype.push.apply(this.centrosCustos, resp.data);               
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoExcluir = permissoes.includes(105);				
		}
    },
    created() {
        this.controlePontoService = new ControlePontoService();
        this.afastamentoService = new AfastamentoService();
        this.centroCustoService = new CentroCustoService();       
    },
    mounted() {       
        this.validarPermissoes();
    }
}
</script>

<style>

</style>